export type NewOption = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __isNew__: true;
  label: string;
  value: string;
};

export function isNewOption<Option extends object>(
  option: Option | NewOption,
): option is NewOption {
  return "__isNew__" in option;
}
